import { Spinner } from '@/components/Spinner';
import { useResponsive } from '@/hooks/useResponsive';
import { Flex } from '@/layouts/Flex';
import { Colors } from '@/plugins/data/colors';
import ReactPlayer from 'react-player';
import { Link } from 'react-router';
import styles from './styles.module.scss';

export function HomePage() {
  const { isMobile } = useResponsive();

  return (
    <>
      <section className={styles.banner}>
        <div className={styles.bannerContent}>
          <img src='/identity/svg/full_horizontal/type_4.svg' alt='logo' />
          <p>Vídeos sobre la primera visita al dentista para pacientes con TEA</p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.container}>
          <Flex
            flexDirection={isMobile ? 'column' : 'row'}
            alignItems={isMobile ? 'center' : 'stretch'}
            gap={isMobile ? 24 : 36}>
            {isMobile ? <p className={styles.eyebrow}>Bienvenido</p> : null}
            {isMobile ? <h2 className={styles.title}>Conoce DienTEA y su equipo de profesionales</h2> : null}
            <div className={styles.video}>
              <Flex justifyContent='center' alignItems='center' className={styles.videoElement}>
                <ReactPlayer
                  src='https://youtube.com/shorts/mJTZSZd9L38'
                  fallback={<Spinner />}
                  // width='100%'
                  height='100%'
                />
              </Flex>
            </div>

            <Flex
              flexDirection='column'
              // justifyContent='flex-start'
              alignItems={isMobile ? 'center' : 'flex-start'}
              className={styles.content}>
              {!isMobile ? <p className={styles.eyebrow}>Bienvenido</p> : null}
              {!isMobile ? <h2 className={styles.title}>Conoce DienTEA y su equipo de profesionales</h2> : null}
              <p className={styles.subtitle}>Después, elige cómo quieres preparar la visita al dentista</p>

              <Flex flexDirection='column' gap={10}>
                <Link to='/reviews' className={`${styles.actionCard} ${styles.actionCardBlue}`}>
                  <span className={styles.iconCircle} aria-hidden='true'>
                    <PlayIcon />
                  </span>
                  <Flex flexDirection='column' className={styles.actionText}>
                    <span className={styles.actionLabel}>Ver vídeos</span>
                    <span className={styles.actionDescription}>Anticipa la visita paso a paso</span>
                  </Flex>
                  {!isMobile ? (
                    <span className={styles.chevron} aria-hidden='true'>
                      <ChevronIcon />
                    </span>
                  ) : null}
                </Link>

                <Link to='/pictograms' className={`${styles.actionCard} ${styles.actionCardRed}`}>
                  <span className={styles.iconCircle} aria-hidden='true'>
                    <PictogramIcon />
                  </span>
                  <Flex flexDirection='column' className={styles.actionText}>
                    <span className={styles.actionLabel}>Ver pictogramas</span>
                    <span className={styles.actionDescription}>Material visual de apoyo</span>
                  </Flex>
                  {!isMobile ? (
                    <span className={styles.chevron} aria-hidden='true'>
                      <ChevronIcon />
                    </span>
                  ) : null}
                </Link>
              </Flex>
            </Flex>
          </Flex>
        </div>

        <div style={{ margin: '3rem auto', maxWidth: '920px' }}>
          {/* <p>
            En los últimos años, muchas familias recurren a Internet y, especialmente, a YouTube™️ para buscar
            información sobre cómo preparar a sus hijos para la primera visita al dentista. Esto es aún más frecuente
            cuando se trata de niños con Trastorno del Espectro Autista (TEA), ya que las visitas odontológicas pueden
            generar ansiedad, incertidumbre y muchas preguntas en casa.
          </p> */}
          <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '0 0 1.5rem' }} />
          <section style={{ padding: '0 2rem 0' }}>
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                background: Colors.primaryOpacity,
                color: Colors.primaryDark,
                fontSize: 11,
                fontWeight: 600,
                padding: '4px 10px',
                borderRadius: 999,
                marginBottom: '1rem',
                letterSpacing: '0.06em',
                textTransform: 'uppercase'
              }}>
              ¿Por qué DienTEA?
            </span>

            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827', margin: '0 0 1rem', lineHeight: 1.35 }}>
              Las familias buscan ayuda antes de la visita
            </h2>

            <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.75, margin: 0 }}>
              En los últimos años, muchas familias recurren a Internet y, especialmente, a YouTube para preparar a sus
              hijos antes de ir al dentista. Esto es aún más frecuente cuando se trata de niños con Trastorno del
              Espectro Autista (TEA), ya que las visitas odontológicas pueden generar ansiedad, incertidumbre y muchas
              preguntas en casa.
            </p>

            <div
              style={{
                borderLeft: '3px solid #1a8ac4',
                padding: '0.75rem 1.25rem',
                marginTop: '1.5rem',
                background: '#EFF6FF',
                borderRadius: '0 8px 8px 0'
              }}>
              <p style={{ fontSize: 13, color: '#1e40af', margin: 0, lineHeight: 1.6, fontStyle: 'italic' }}>
                Las visitas odontológicas pueden generar ansiedad e incertidumbre — DienTEA ofrece recursos pensados
                específicamente para familias con niños TEA.
              </p>
            </div>
            <div style={{ marginTop: '2rem' }}>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  background: Colors.primaryOpacity,
                  color: Colors.primaryDark,
                  fontSize: 11,
                  fontWeight: 600,
                  padding: '4px 10px',
                  borderRadius: 999,
                  marginBottom: '1rem',
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase'
                }}>
                Nuestro equipo
              </span>
              <picture style={{ width: isMobile ? '100%' : '80%', margin: '0 auto', marginTop: isMobile ? 0 : 12 }}>
                <source srcSet='/images/team.webp' type='image/webp' style={{ borderRadius: 8 }} />
                <img
                  src='/images/team.png'
                  alt='Foto del equipo de DienTEA'
                  loading='lazy'
                  style={{ borderRadius: 8 }}
                />
              </picture>
            </div>
          </section>
        </div>
      </section>
    </>
  );
}

const PlayIcon = () => (
  <svg width='20' height='20' viewBox='0 0 24 24' aria-hidden='true'>
    <path d='M8 5v14l11-7z' fill='currentColor' />
  </svg>
);
const PictogramIcon = () => (
  <svg width='18' height='18' viewBox='0 0 24 24' aria-hidden='true'>
    <rect x='3' y='3' width='7.5' height='7.5' rx='1.5' fill='currentColor' />
    <rect x='13.5' y='3' width='7.5' height='7.5' rx='1.5' fill='currentColor' />
    <rect x='3' y='13.5' width='7.5' height='7.5' rx='1.5' fill='currentColor' />
    <rect x='13.5' y='13.5' width='7.5' height='7.5' rx='1.5' fill='currentColor' />
  </svg>
);
const ChevronIcon = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.5'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'>
    <path d='M9 18l6-6-6-6' />
  </svg>
);
